import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Layout, Menu, Button, Typography, Space, Dropdown } from 'antd';
import {
  DashboardOutlined,
  PictureOutlined,
  VideoCameraOutlined,
  AudioOutlined,
  CustomerServiceOutlined,
  KeyOutlined,
  LogoutOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/branding/logo.png';
import './layout.css';

const { Header, Sider, Content } = Layout;

export default function MainLayout() {
  const nav = useNavigate();
  const loc = useLocation();
  const { username, logout } = useAuth();
  const selected = loc.pathname === '/' ? '/' : `/${loc.pathname.split('/')[1]}`;

  return (
    <Layout className="shell">
      <Sider width={232} className="shell-sider" breakpoint="lg" collapsedWidth={72}>
        <div className="brand" onClick={() => nav('/')}>
          <img src={logo} alt="MOCUT" className="brand-logo" />
          <div>
            <div className="brand-name">MOCUT</div>
            <div className="brand-sub">Assets Console</div>
          </div>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selected]}
          onClick={({ key }) => nav(key)}
          items={[
            { key: '/', icon: <DashboardOutlined />, label: '总览' },
            { key: '/images', icon: <PictureOutlined />, label: '图片' },
            { key: '/videos', icon: <VideoCameraOutlined />, label: '视频' },
            { key: '/sfx', icon: <AudioOutlined />, label: '音效' },
            { key: '/bgm', icon: <CustomerServiceOutlined />, label: 'BGM' },
            { key: '/clients', icon: <KeyOutlined />, label: 'OpenAPI 凭证' },
          ]}
        />
      </Sider>
      <Layout>
        <Header className="shell-header">
          <Typography.Text className="header-hint">专业素材资源中枢</Typography.Text>
          <Dropdown
            menu={{
              items: [
                {
                  key: 'logout',
                  icon: <LogoutOutlined />,
                  label: '退出登录',
                  onClick: () => {
                    logout();
                    nav('/login');
                  },
                },
              ],
            }}
          >
            <Button type="text" className="user-btn" icon={<UserOutlined />}>
              <Space>{username || 'admin'}</Space>
            </Button>
          </Dropdown>
        </Header>
        <Content className="shell-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
